import ZendeskRedirect from '@/support/pages/ZendeskRedirect'

export default [
	{
        path: '/zendesk/sso',
        name: 'ZendeskRedirect',
        component: ZendeskRedirect
    },
    {
    	path: '/support',
    	name: 'Support',
    	beforeEnter (to, from, next) {
    		window.location = 'https://smartrtb.zendesk.com/hc/en-us/requests'
    	}
    }
]




// WEBPACK FOOTER //
// ./src/support/routes.js